import { axiosInstance } from "../../../hoc/Axios/Axios";
import * as actions from "../../Actions";

export const createPayTaskHistory = data => dispatch => axiosInstance
    .post("pay-task-histories", data)
    .then(() => {
        dispatch({ type: actions.CREATE_PAY_TASK_HISTORY, payload: true });
    })
    .catch(() => null)
